import { useState } from 'react';
import { MdMoreVert } from 'react-icons/md';
import { Button } from '@/components/Button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import RenameListDialog from './RenameListDialog';
import VisibilityDialog from './VisibilityDialog';
import DeleteListDialog from './DeleteListDialog';

interface Props {
  listId: string;
  listName: string;
  isPublic: boolean;
  isOwner: boolean;
  onDeleted?: () => void;
}

export default function ListActionMenu({ listId, listName, isPublic, isOwner, onDeleted }: Props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isRenameOpen, setIsRenameOpen] = useState(false);
  const [isVisibilityOpen, setIsVisibilityOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  if (!isOwner) return null;

  return (
    <>
      <Popover open={isMenuOpen} onOpenChange={setIsMenuOpen}>
        <PopoverTrigger asChild>
          <Button color="secondary" size="sm" iconOnly onClick={(e) => e.stopPropagation()}>
            <MdMoreVert className="size-icon-xxs" />
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-[180px] rounded-sm p-0 shadow-layer3">
          <div className="flex flex-col">
            {isOwner && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsMenuOpen(false);
                  setIsRenameOpen(true);
                }}
                className="flex h-xxl items-center px-md py-xs text-body-sm text-main hover:bg-gray"
              >
                名前を変更
              </button>
            )}
            {isOwner && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsMenuOpen(false);
                  setIsVisibilityOpen(true);
                }}
                className="flex h-xxl items-center px-md py-xs text-body-sm text-main hover:bg-gray"
              >
                {isPublic ? '非公開にする' : '公開する'}
              </button>
            )}
            {isOwner && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsMenuOpen(false);
                  setIsDeleteOpen(true);
                }}
                className="flex h-xxl items-center px-md py-xs text-body-sm text-danger hover:bg-gray"
              >
                リストを削除
              </button>
            )}
          </div>
        </PopoverContent>
      </Popover>

      <RenameListDialog
        open={isRenameOpen}
        onOpenChange={setIsRenameOpen}
        listId={listId}
        currentName={listName}
      />
      <VisibilityDialog
        open={isVisibilityOpen}
        onOpenChange={setIsVisibilityOpen}
        listId={listId}
        listName={listName}
        isPublic={isPublic}
      />
      <DeleteListDialog
        open={isDeleteOpen}
        onOpenChange={setIsDeleteOpen}
        listId={listId}
        listName={listName}
        onDeleted={onDeleted}
      />
    </>
  );
}
